/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2026] Narbase Technologies
 * All Rights Reserved.
 * Created by shalaga44
 * On: 21/Sep/2026.
 */

@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.favoritepoints

import com.narbase.letsgo.router.EndPoint

object GetFavoritePointsSearchStatusEndpoint :
    EndPoint<GetFavoritePointsSearchStatusEndpoint.Request, GetFavoritePointsSearchStatusEndpoint.Response>() {
    class Request

    class Response(
        val isActive: Boolean,
        val isReachable: Boolean,
        val indexExists: Boolean,
        val indexedFavoritePointsCount: Int,
        val databaseFavoritePointsCount: Int,
        val error: String?,
    )
}
